function isMobile() {
    return window.matchMedia("( max-width: 767px )").matches;
}

export default ( object = {} ) => ( {
    Player: null,
    videoSet: [],
    token: 'unset',
    currentToken: null,
    get isReady() {
        return !!this.Player;
    },
    setVideos() {
        let newToken = isMobile() ? 'mobile' : 'desktop';
        if ( newToken == this.currentToken ) {
            return;
        }
        this.token = newToken;
        this.videoSet = isMobile() ? object.mobile : object.desktop;
        this.Player.load();
        this.currentToken = newToken;
    },
    init() {
        // console.log( "Homepage FeaturedMasthead Video", { object, 'debounce': Alpine.debounce } );
        if ( Object.keys( object ).length === 0 ) { return; }
        this.Player = this.$root.querySelector( 'video' );
        if ( !this.Player ) { return; }
        window.addEventListener("resize", Alpine.debounce( (event ) => {
            this.setVideos();
        }, 100 ) );
        this.setVideos();
    }
} );
